import React from 'react'

export default function ShoppingMethod() {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_443_5933)'>
        <path
          d='M16.25 7.5H13C12.5125 7.5 12.1875 7.825 12.1875 8.3125V14H8.125V14.8125C8.125 15.3 8.45 15.625 8.9375 15.625H13C13 14.7312 13.7312 14 14.625 14C15.5188 14 16.25 14.7312 16.25 15.625H17.0625C17.55 15.625 17.875 15.3 17.875 14.8125V11.5625L16.25 7.5Z'
          fill='#A1A5B7'
        />
        <path
          opacity='0.3'
          d='M16.25 15.625C16.25 16.5188 15.5188 17.25 14.625 17.25C13.7312 17.25 13 16.5188 13 15.625C13 14.7312 13.7312 14 14.625 14C15.5188 14 16.25 14.7312 16.25 15.625ZM12.1875 4.25C12.1875 3.7625 11.8625 3.4375 11.375 3.4375H2.4375C1.95 3.4375 1.625 3.7625 1.625 4.25V11.5625C1.625 12.05 1.95 12.375 2.4375 12.375H12.1875V4.25ZM4.875 14C3.98125 14 3.25 14.7312 3.25 15.625C3.25 16.5188 3.98125 17.25 4.875 17.25C5.76875 17.25 6.5 16.5188 6.5 15.625C6.5 14.7312 5.76875 14 4.875 14Z'
          fill='#A1A5B7'
        />
      </g>
      <defs>
        <clipPath id='clip0_443_5933'>
          <rect width='19.5' height='19.5' fill='white' transform='translate(0.46875 0.711914)' />
        </clipPath>
      </defs>
    </svg>
  )
}
